export interface PillarArticle {
  key: string;
  image: string;
  readingTime: number;
}

export const pillarArticles: PillarArticle[] = [
  {
    key: 'spreadsheetGuide',
    readingTime: 6,
    image: 'https://readdy.ai/api/search-image?query=A%20sleek%20laptop%20displaying%20a%20colorful%20product%20spreadsheet%20grid%20with%20images%20and%20data%20columns%20on%20a%20bright%20minimal%20desk%2C%20soft%20natural%20light%2C%20clean%20modern%20workspace%20photography%2C%20high%20detail%2C%20editorial%20composition&width=800&height=600&seq=pillar-spreadsheet-guide&orientation=landscape',
  },
  {
    key: 'howToUse',
    readingTime: 5,
    image: 'https://readdy.ai/api/search-image?query=A%20person%20browsing%20a%20fashion%20product%20catalog%20on%20a%20smartphone%20held%20over%20a%20light%20desk%20with%20soft%20natural%20light%2C%20minimal%20lifestyle%20photography%2C%20clean%20modern%20aesthetic%2C%20high%20detail%2C%20editorial%20composition&width=800&height=600&seq=pillar-how-to-use&orientation=landscape',
  },
  {
    key: 'directory',
    readingTime: 4,
    image: 'https://readdy.ai/api/search-image?query=An%20organized%20directory%20list%20concept%20with%20colorful%20tabs%20and%20category%20folders%20arranged%20on%20a%20light%20desk%2C%20soft%20natural%20lighting%2C%20minimal%20flat%20lay%20photography%2C%20clean%20modern%20aesthetic%2C%20high%20detail&width=800&height=600&seq=pillar-directory&orientation=landscape',
  },
  {
    key: 'review',
    readingTime: 7,
    image: 'https://readdy.ai/api/search-image?query=A%20close%20up%20of%20a%20five%20star%20rating%20and%20a%20review%20card%20with%20text%20on%20a%20light%20background%2C%20soft%20natural%20lighting%2C%20minimal%20photography%2C%20clean%20modern%20aesthetic%2C%20high%20detail%2C%20editorial%20composition&width=800&height=600&seq=pillar-review&orientation=landscape',
  },
  {
    key: 'shippingCost',
    readingTime: 6,
    image: 'https://readdy.ai/api/search-image?query=A%20measuring%20tape%20and%20a%20cardboard%20delivery%20box%20with%20shipping%20labels%20on%20a%20light%20studio%20background%2C%20soft%20even%20lighting%2C%20minimal%20product%20photography%2C%20clean%20modern%20aesthetic%2C%20high%20detail&width=800&height=600&seq=pillar-shipping-cost&orientation=landscape',
  },
  {
    key: 'warehouse',
    readingTime: 6,
    image: 'https://readdy.ai/api/search-image?query=A%20clean%20modern%20fulfillment%20warehouse%20with%20rows%20of%20organized%20shelves%20and%20stacked%20boxes%2C%20bright%20even%20lighting%2C%20minimal%20photography%2C%20fresh%20modern%20aesthetic%2C%20high%20detail%2C%20editorial%20composition&width=800&height=600&seq=pillar-warehouse&orientation=landscape',
  },
  {
    key: 'coupon',
    readingTime: 5,
    image: 'https://readdy.ai/api/search-image?query=Colorful%20discount%20coupon%20cards%20and%20a%20pair%20of%20scissors%20on%20a%20light%20background%2C%20soft%20natural%20lighting%2C%20minimal%20flat%20lay%20photography%2C%20clean%20modern%20aesthetic%2C%20high%20detail%20paper%20texture&width=800&height=600&seq=pillar-coupon&orientation=landscape',
  },
  {
    key: 'legit',
    readingTime: 5,
    image: 'https://readdy.ai/api/search-image?query=A%20green%20verified%20badge%20and%20shield%20icon%20on%20a%20light%20background%20representing%20trust%2C%20soft%20even%20lighting%2C%20minimal%203d%20render%2C%20clean%20modern%20aesthetic%2C%20high%20detail&width=800&height=600&seq=pillar-legit&orientation=landscape',
  },
  {
    key: 'buyingGuide',
    readingTime: 8,
    image: 'https://readdy.ai/api/search-image?query=A%20shopping%20cart%20with%20a%20paper%20checklist%20and%20a%20credit%20card%20on%20a%20light%20desk%2C%20soft%20natural%20lighting%2C%20minimal%20photography%2C%20clean%20modern%20aesthetic%2C%20high%20detail%2C%20editorial%20composition&width=800&height=600&seq=pillar-buying-guide&orientation=landscape',
  },
  {
    key: 'safety',
    readingTime: 5,
    image: 'https://readdy.ai/api/search-image?query=A%20padlock%20and%20shield%20security%20concept%20with%20a%20key%20on%20a%20light%20background%2C%20soft%20even%20lighting%2C%20minimal%203d%20render%20photography%2C%20clean%20modern%20aesthetic%2C%20high%20detail&width=800&height=600&seq=pillar-safety&orientation=landscape',
  },
];